import React from 'react';
import Form from 'react-bootstrap/Form';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {CRQ_FORM_FOCUS, FILE_POSTFIX} from "../../common/constants";


//Fragment to handle selection of a local file to be uploaded
export default function SmartFile(props) {
  return (
    <Form.Group as={Row} className="p-2">
      <Form.Label column sm="3">{props.label}</Form.Label>
      <Col sm="9" name={CRQ_FORM_FOCUS}>
        <Form.Control
          type="file"
          accept={props.accept}
          name={props.name + FILE_POSTFIX}
          id={props.name + FILE_POSTFIX}
          placeholder={props.placeholder}
          required={props.required}
          title={props.title}
          defaultValue={props.defaultValue}/>
        <Form.Control.Feedback type="invalid">{props.feedback}</Form.Control.Feedback>
      </Col>
    </Form.Group>
  )
}